import { DharmachakraIcon } from './DharmachakraIcon';

/**
 * author: Nick
 * id 18A94F7F-1BC5-48EC-9CAF-6D2D663287DC
 * name dharmachakra
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dharmachakra.svg
 * tags
 * - Religion 
 */
export const DharmaWheelIcon = DharmachakraIcon;
export default DharmaWheelIcon